import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from "recharts";

export default function PhaseApparentEnergyBars({ deviceId, API_BASE }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch(
          `${API_BASE}/measurements/energy/apparent?deviceId=${deviceId}`
        );
        const json = await res.json();

        const rows = [
          {
            phase: "L1",
            importVal: Math.trunc(((json.S1_IMPORT ?? 0) / 1000) * 1000) / 1000,
            exportVal: Math.trunc(((json.S1_EXPORT ?? 0) / 1000) * 1000) / 1000,

          },
          {
            phase: "L2",
            importVal: Math.trunc(((json.S2_IMPORT ?? 0) / 1000) * 1000) / 1000,
            exportVal: Math.trunc(((json.S2_EXPORT ?? 0) / 1000) * 1000) / 1000,

          },
          {
            phase: "L3",
            importVal: Math.trunc(((json.S3_IMPORT ?? 0) / 1000) * 1000) / 1000,
            exportVal: Math.trunc(((json.S3_EXPORT ?? 0) / 1000) * 1000) / 1000,

          },
          {
            phase: "Toplam",
            importVal: Math.trunc(((json.ST_IMPORT ?? 0) / 1000) * 1000) / 1000,
            exportVal: Math.trunc(((json.ST_EXPORT ?? 0) / 1000) * 1000) / 1000,

          },
        ];

        setData(rows);
      } catch (err) {
        console.error("PhaseApparentEnergyBars error:", err);
      }
    }

    load();
    const int = setInterval(load, 15000);
    return () => clearInterval(int);
  }, [deviceId, API_BASE]);

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5">
      <h3 className="text-sm font-semibold text-slate-700 mb-3">
        {t('energies.phaseApparentTitle')}
      </h3>

      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />

            <XAxis dataKey="phase" stroke="#6B7280" />
            <YAxis stroke="#6B7280" />
            <Tooltip formatter={(v) => `${v.toFixed(3)} kVAh`} />
            <Legend />

            <Bar dataKey="importVal" name={t('energies.importkVAh')} fill="#4F46E5" />
            <Bar dataKey="exportVal" name={t('energies.exportkVAh')} fill="#F59E0B" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
